import { BillingIntervalProto } from "@noom/noom-contracts/noom_contracts/billing/billing_interval";

export type LongDurationWeekCount = 24 | 48;

/**
 * The length of the long duration plan an order is on, read off the cycle
 * billing charges it over. Billing reports plan duration in weeks, the same
 * unit these plans are sold in, so the length is taken rather than recognized
 * from a plan id. Absent when the order is not on one of these plans.
 */
export function getLongDurationWeeksFromBillingInterval(
  billingInterval?: BillingIntervalProto
): LongDurationWeekCount | undefined {
  if (billingInterval?.unit !== "WEEKS") {
    return undefined;
  }

  const { count } = billingInterval;

  return count === 24 || count === 48 ? count : undefined;
}
